import template from './name-and-year-commercial.jade';

export default angular
  .module('cian.addForm.nameAndYearCommercial', [])
  .directive('cianAfAboutBuildingNameAndYearCommercial', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller() {},
    controllerAs: 'nameAndYearCommercial',
    template,
  })).name;
